(() => {
  if (window.llMaterialCardPages) return;
  window.llMaterialCardPages = true;

  const batchSize = 25;
  const states = new WeakMap();

  function setup(grid) {
    if (states.has(grid)) return states.get(grid);

    const controls = document.createElement('div');
    controls.className = 'll-material-card-pages';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn--tertiary';
    button.textContent = document.documentElement.lang.startsWith('en') ? 'Show more materials' : 'Toon meer materialen';
    button.setAttribute('aria-controls', grid.id);
    controls.append(button);
    grid.after(controls);

    const state = { visible: batchSize, controls, button, render: null };
    state.render = ({ reset = false } = {}) => {
      if (reset) state.visible = batchSize;
      const cards = Array.from(grid.children).filter((card) => card.matches('.ll-material-card'));
      const eligible = cards.filter((card) => card.dataset.llVariantFilterHidden !== 'true');
      const visibleCards = new Set(eligible.slice(0, state.visible));
      cards.forEach((card) => { card.hidden = !visibleCards.has(card); });
      button.hidden = state.visible >= eligible.length;

      const serverPagination = grid.parentElement.querySelector('.pagination');
      if (serverPagination) serverPagination.hidden = state.visible < eligible.length;
    };

    button.addEventListener('click', () => {
      const cards = Array.from(grid.children).filter((card) => card.matches('.ll-material-card'));
      const eligible = cards.filter((card) => card.dataset.llVariantFilterHidden !== 'true');
      const next = eligible[state.visible];
      state.visible += batchSize;
      state.render();
      next?.querySelector('a')?.focus({ preventScroll: true });
    });

    states.set(grid, state);
    state.render();
    return state;
  }

  function initialize() {
    document.querySelectorAll('[data-material-card-pages]').forEach((grid) => setup(grid));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('ll:material-variant-filtered', () => {
    document.querySelectorAll('[data-material-card-pages]').forEach((grid) => setup(grid).render({ reset: true }));
  });
  // Motion replaces the result fragment when filters change.
  new MutationObserver(initialize).observe(document.documentElement, { childList: true, subtree: true });
})();
